(() => {
  const init = () => {
    document.querySelectorAll('[data-cp-gallery-map]').forEach(config => {
      const root = config.closest('.shopify-section');
      if (!root || config.dataset.ready) return;
      config.dataset.ready = 'true';
      const map = JSON.parse(config.textContent);
      let target;
      const show = () => {
        if (!target) return;
        root.querySelectorAll('media-gallery, media-gallery-mobile').forEach(gallery => {
          const slider = gallery.slider;
          if (!slider || slider.destroyed) return;
          const slides = Array.from(slider.slides || []);
          const slide = slides.find(item => item.querySelector(`[data-media-id="${target}"]`));
          if (!slide) return;
          const index = Number(slide.dataset.swiperSlideIndex ?? slides.indexOf(slide));
          const speed = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 250;
          if (slider.params.loop) slider.slideToLoop(index, speed);
          else slider.slideTo(index, speed);
        });
      };
      root.addEventListener('change', event => {
        const group = event.target.closest('variant-picker [data-option-name]');
        if (!group) return;
        const option = group.dataset.optionName;
        if (option === 'Frame Color') target = /^2-Tone:/i.test(event.target.value) ? map.twoTone : map.solid;
        else target = map[option];
        show();
      });
      root.addEventListener('focusin', event => {
        if (event.target.id === 'cp_lettering') { target = map.lettering; show(); }
      });
      document.addEventListener('variant:changed', event => {
        if (event.detail?.variant && root.querySelector('variant-picker')?.currentVariant?.id === event.detail.variant.id) requestAnimationFrame(show);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
